import { isDesktop } from '@global/helpers/general';
import { ArrowBack } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Dialog, IconButton, Slide, SxProps, Toolbar, Typography } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

const Transition: React.JSXElementConstructor<
  TransitionProps & {
    children: React.ReactElement<any, any>
  }
> = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface FullScreenDialogProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  fullScreen?: boolean;
  title?: string;
  sx?: SxProps;
  goBackOnClose?: boolean;
  children?: React.ReactNode;
}

export default function FullScreenDialog(props: FullScreenDialogProps) {
  const { title, fullScreen = true, open, setOpen, sx, children, goBackOnClose } = props;
  const navigate = useNavigate();
  const matches = isDesktop();
  const isFullScreen = fullScreen === true ? true : matches ? false : true;
  const handleClose = () => {
    if (goBackOnClose) {
      return navigate(-1);
    }
    setOpen(false);
  };
  return (
    <Dialog
      fullScreen={isFullScreen}
      maxWidth={fullScreen === true ? 'xl' : matches ? 'sm' : 'xl'}
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      sx={sx}>
      <AppBar sx={{ position: 'relative' }} color="primary">
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
            <ArrowBack />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1, color: '#ffffff' }} variant="h6" component="div">
            {title}
          </Typography>
          <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      {children}
    </Dialog>
  );
}
